import './topfilters.scss';

import Icon, { IconType } from '../icon/Icon';

import { ChangeEvent } from 'react';
import { IFilterDisplay } from '../../lib/system-selector/interfaces';
import ScrollableContainer from '../scrollable-container/ScrollableContainer';
import classNames from 'classnames';

interface TopFiltersProps {
  primaryFilters?: IFilterDisplay[];
  secondaryFilters?: IFilterDisplay[];
  onPrimaryChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onSecondaryChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

const TopFilters = ({
  primaryFilters,
  secondaryFilters,
  onPrimaryChange,
  onSecondaryChange,
}: TopFiltersProps) => {
  return (
    <ScrollableContainer className="u-mb-5">
      <div className="top-filters">
        {primaryFilters && primaryFilters.length > 0 && (
          <div className="top-filters__list">
            {primaryFilters.map((filter, index) => (
              <label
                key={index}
                htmlFor={`primary-filters-${index}`}
                className={classNames('top-filters__item', {
                  active: filter.active,
                })}
              >
                <input
                  type="checkbox"
                  id={`primary-filters-${index}`}
                  checked={!!filter.active}
                  value={filter.filterDisplayLabel}
                  onChange={onPrimaryChange}
                />
                {filter.filterDisplayLabel}
              </label>
            ))}
          </div>
        )}
        {secondaryFilters && secondaryFilters.length > 0 && (
          <div className="top-filters__list">
            {secondaryFilters.map((filter, index) => (
              <label
                key={index}
                htmlFor={`secondary-filters-${index}`}
                className={classNames('top-filters__item', {
                  active: filter.active,
                })}
              >
                <input
                  type="checkbox"
                  id={`secondary-filters-${index}`}
                  checked={!!filter.active}
                  value={filter.filterDisplayLabel}
                  className="top-filters-checkbox"
                  onChange={onSecondaryChange}
                />
                <Icon
                  iconType={IconType.Available}
                  className="u-icon-tiny u-mie-2"
                />
                {filter.filterDisplayLabel}
              </label>
            ))}
          </div>
        )}
      </div>
    </ScrollableContainer>
  );
};

export default TopFilters;
